import { styled } from "@vitality-ds/system";
import basePaginationStyles from "./styles/BasePagination.styles";
import baseWrapper from "./styles/PaginationWrapper.styles";

// eslint-disable-next-line import/prefer-default-export
export var BasePagination = styled("div", basePaginationStyles);
export var PaginationWrapper = styled("div", baseWrapper);